import { Checkbox, Fieldset, ValidationMessage } from '@digdir/designsystemet-react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { LeftPaddedContent } from '../common/styledComponents';
import { TermostatstyringRadio } from '../common/termostatstyringRadio';
import { OppvarmingFormData } from '../../../types';

import { useFjernvarmeValidation } from './useFjernvarmeValidation';

export const Fordelingssystem = () => {
  const { register, watch, formState } = useFormContext<OppvarmingFormData>();
  const { t } = useTranslation();
  const { validateFordelingssystemSelection } = useFjernvarmeValidation();

  const gulvvarmeSelected = watch('fjernvarme.value.gulvvarme.selected');
  const radiatorSelected = watch('fjernvarme.value.radiator.selected');

  const errors = formState.errors?.fjernvarme?.value;

  // Radiator and gulvvarme is validated as a group and share the exact same validation and error message.
  // We only display radiator error message.
  const fordelingssystemSelectionError = errors?.radiator?.selected;

  return (
    <Fieldset>
      <Fieldset.Legend>{t('form.oppvarming.common.kjel.fordelingssystem.label')}</Fieldset.Legend>
      <Checkbox
        label={t('form.oppvarming.common.kjel.fordelingssystem.gulvvarme.label')}
        aria-invalid={!!errors?.gulvvarme?.selected}
        {...register('fjernvarme.value.gulvvarme.selected', {
          validate: validateFordelingssystemSelection,
          deps: ['fjernvarme.value.romoppvarming.value.radiator.selected'],
          shouldUnregister: true
        })}
      />
      {gulvvarmeSelected && (
        <LeftPaddedContent>
          <TermostatstyringRadio labelHidden name="fjernvarme.value.gulvvarme.value.termostatstyring" />
        </LeftPaddedContent>
      )}

      <Checkbox
        label={t('form.oppvarming.common.kjel.fordelingssystem.radiator.label')}
        aria-invalid={!!errors?.radiator?.selected}
        {...register('fjernvarme.value.radiator.selected', {
          validate: validateFordelingssystemSelection,
          deps: ['fjernvarme.value.romoppvarming.value.gulvvarme.selected'],
          shouldUnregister: true
        })}
      />
      {radiatorSelected && (
        <LeftPaddedContent>
          <TermostatstyringRadio labelHidden name="fjernvarme.value.radiator.value.termostatstyring" />
        </LeftPaddedContent>
      )}
      {!!fordelingssystemSelectionError && (
        <ValidationMessage>{fordelingssystemSelectionError.message}</ValidationMessage>
      )}
    </Fieldset>
  );
};
